import type { RoutingConfig } from '../types';

export const ROUTING_DATA: RoutingConfig[] = [
	{
		id: 1,
		name: 'Email Fallback Chain',
		type: 'Fallback Chain',
		subdomain: 'Mail',
		desc: 'SendGrid → Mailgun → AWS SES',
		status: 'Active',
		created: 'Apr 20, 2026',
		connectors: [
			{ logo: 'SG', name: 'SendGrid', label: 'Transactional', pos: 1 },
			{ logo: 'MG', name: 'Mailgun', label: 'Backup', pos: 2 },
			{ logo: 'SES', name: 'AWS SES', label: 'Emergency', pos: 3, err: true },
		],
	},
	{
		id: 2,
		name: 'Email Weighted Split',
		type: 'Weighted Split',
		subdomain: 'Mail',
		desc: 'SendGrid 60% / Mailgun 40%',
		status: 'Inactive',
		created: 'Apr 18, 2026',
		connectors: [
			{ logo: 'SG', name: 'SendGrid', label: 'Marketing', weight: 60 },
			{ logo: 'MG', name: 'Mailgun', label: 'Backup', weight: 40 },
		],
	},
	{
		id: 3,
		name: 'Push Weighted Split',
		type: 'Weighted Split',
		subdomain: 'Push',
		desc: 'FCM 60% / APNs 40%',
		status: 'Active',
		created: 'Apr 08, 2026',
		connectors: [
			{ logo: 'FCM', name: 'FCM', label: 'Android Push', weight: 60 },
			{ logo: 'APNs', name: 'APNs', label: 'iOS Push', weight: 40 },
		],
	},
	{
		id: 4,
		name: 'SMS Volume Cap',
		type: 'Volume Cap Overflow',
		subdomain: 'SMS',
		desc: 'Twilio → Infobip (10k/day)',
		status: 'Active',
		created: 'Apr 05, 2026',
		connectors: [
			{ logo: 'TW', name: 'Twilio', label: 'Primary SMS', cap: 10000 },
			{ logo: 'IB', name: 'Infobip', label: 'SMS Fallback', role: 'overflow' },
		],
	},
];
